"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZPrizeImageLocations = exports.ZPrizeImageLocationsBase = exports.ZPlayerABTestVariant = exports.ZSubscriptionHistoryAdditionalInfo = exports.ZFeedbackContent = exports.ZPriceTable = exports.ZSimulatedWinners = exports.ZDrawTypeFullResult = exports.ZLeaderboardResult = exports.ZRaffleResult = exports.ZLotteryDrawResult = exports.ZLeaderboardResultAdditionalInfo = exports.ZEntryLine = exports.ZLeaderboardEntry = exports.ZRaffleEntry = exports.ZLotteryDrawEntry = exports.ZDrawTypeNumberSetup = exports.ZPromoConditions = void 0;
const zod_1 = require("zod");
const dbEnums_1 = require("./dbEnums");
///
/// This file contains strongly-typed JSON models that are used by the DB schemas and also have to appear in API
/// contracts that the front end uses. These zod models will end up in the frontend bundle.
///
exports.ZPromoConditions = zod_1.z.object({
    isftmp: zod_1.z.boolean(),
    isSubscribed: zod_1.z.boolean(),
    drawTypeCode: zod_1.z.string(),
    planCode: zod_1.z.string(),
    planSubcode: zod_1.z.string(),
    numEntries: zod_1.z.number(),
    scheduleCode: zod_1.z.string(),
});
exports.ZDrawTypeNumberSetup = zod_1.z.object({
    type: zod_1.z.literal(dbEnums_1.GameType.LOTTERY),
    main: zod_1.z.number().array(),
    bonus: zod_1.z.number().array(),
});
exports.ZLotteryDrawEntry = zod_1.z.object({
    type: zod_1.z.literal(dbEnums_1.GameType.LOTTERY),
    main: zod_1.z.number().array(),
    bonus: zod_1.z.number().array(),
});
exports.ZRaffleEntry = zod_1.z.object({
    type: zod_1.z.literal(dbEnums_1.GameType.RAFFLE),
    raffle: zod_1.z.string(),
});
exports.ZLeaderboardEntry = zod_1.z.object({
    type: zod_1.z.literal(dbEnums_1.GameType.LEADERBOARD),
    points: zod_1.z.number(),
    action: zod_1.z.nativeEnum(dbEnums_1.LeaderboardAction),
    raffle: zod_1.z.string(),
});
exports.ZEntryLine = zod_1.z.union([
    exports.ZLotteryDrawEntry,
    exports.ZRaffleEntry,
    exports.ZLeaderboardEntry,
]);
const ZAdditionalInfo = zod_1.z.object({
    result: zod_1.z.coerce.number().array(),
    verificationPageLink: zod_1.z.string(),
    serialNumber: zod_1.z.coerce.number(),
});
exports.ZLeaderboardResultAdditionalInfo = zod_1.z.object({
    raffleWinner: zod_1.z.object({
        playerId: zod_1.z.string(),
    }),
    leaderPos1: zod_1.z.object({
        playerId: zod_1.z.string(),
        points: zod_1.z.number(),
    }),
    leaderPos2: zod_1.z.object({
        playerId: zod_1.z.string(),
        points: zod_1.z.number(),
    }),
    leaderPos3: zod_1.z.object({
        playerId: zod_1.z.string(),
        points: zod_1.z.number(),
    }),
});
exports.ZLotteryDrawResult = zod_1.z.object({
    type: zod_1.z.literal(dbEnums_1.GameType.LOTTERY),
    main: zod_1.z.number().array(),
    bonus: zod_1.z.number().array(),
    mainAdditionalInfo: zod_1.z.optional(ZAdditionalInfo),
    bonusAdditionalInfo: zod_1.z.optional(ZAdditionalInfo),
});
exports.ZRaffleResult = zod_1.z.object({
    type: zod_1.z.literal(dbEnums_1.GameType.RAFFLE),
    raffle: zod_1.z.string().nullable(),
    raffleAdditionalInfo: zod_1.z.optional(ZAdditionalInfo),
});
exports.ZLeaderboardResult = zod_1.z.object({
    type: zod_1.z.literal(dbEnums_1.GameType.LEADERBOARD),
    raffle: zod_1.z.string().nullable(),
    leaderboardAdditionalInfo: zod_1.z.optional(exports.ZLeaderboardResultAdditionalInfo),
});
exports.ZDrawTypeFullResult = zod_1.z.union([
    exports.ZLotteryDrawResult,
    exports.ZRaffleResult,
    exports.ZLeaderboardResult,
]);
//Record<string, Record<string, string>>
exports.ZSimulatedWinners = zod_1.z.record(zod_1.z.string(), zod_1.z.record(zod_1.z.string(), zod_1.z.string()));
exports.ZPriceTable = zod_1.z.record(zod_1.z.union([
    zod_1.z.record(zod_1.z.literal('GBP'), zod_1.z.record(zod_1.z.number(), zod_1.z.number())),
    zod_1.z.record(zod_1.z.literal('TOKEN'), zod_1.z.record(zod_1.z.number(), zod_1.z.number())),
]));
exports.ZFeedbackContent = zod_1.z.union([
    zod_1.z.object({
        [dbEnums_1.FeedbackAction.CLAIM_PRIZE_WIN]: zod_1.z.object({
            rating: zod_1.z.number(),
            comment: zod_1.z.string().optional(),
        }),
    }),
    zod_1.z.object({
        [dbEnums_1.FeedbackAction.CANCEL_SUBSCRIPTION]: zod_1.z.object({
            comment: zod_1.z.string(),
        }),
    }),
    zod_1.z.object({
        [dbEnums_1.FeedbackAction.TOKEN_TOWN]: zod_1.z.object({
            comment: zod_1.z.string(),
        }),
    }),
    zod_1.z.object({
        /**  TODO: ENG-85 */
        [dbEnums_1.FeedbackAction.SUGGEST_PRIZE]: zod_1.z.object({
            comment: zod_1.z.string(),
        }),
    }),
]);
exports.ZSubscriptionHistoryAdditionalInfo = zod_1.z.record(zod_1.z.string(), zod_1.z.unknown());
exports.ZPlayerABTestVariant = zod_1.z.record(zod_1.z.string(), zod_1.z.string());
exports.ZPrizeImageLocationsBase = zod_1.z.object({
    main: zod_1.z.string(),
    secondary1: zod_1.z.string().nullish(),
    secondary2: zod_1.z.string().nullish(),
});
exports.ZPrizeImageLocations = exports.ZPrizeImageLocationsBase.extend({
    // temporary fields for additional images until we revamp image storage properly
    gallery0: zod_1.z.string().nullish(),
    gallery1: zod_1.z.string().nullish(),
    gallery2: zod_1.z.string().nullish(),
    gallery3: zod_1.z.string().nullish(),
    gallery4: zod_1.z.string().nullish(),
    gallery5: zod_1.z.string().nullish(),
    gallery6: zod_1.z.string().nullish(),
    gallery7: zod_1.z.string().nullish(),
    gallery8: zod_1.z.string().nullish(),
    gallery9: zod_1.z.string().nullish(),
});
//# sourceMappingURL=dbJsonModels.js.map